import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function MobileCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    image: 'https://cdn.magicpatterns.com/uploads/evWTYV3mPBXMkfmjMXBMCC/5_Adios_al_caos_y_estres_laboral.png',
    alt: 'Ordena tu trabajo y dile adiós al estrés laboral'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/orL73XVqQFu9SX7hkvz5Qg/3_Stressful_office_at_twilight.png',
    alt: 'Profesional estresado en oficina'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/1Qp7nAU5LfS5YcKLUdUsN1/4_PROBLEMA-_SOLUCION.png',
    alt: 'Del caos al control - Transformación'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/jh7YcPmtcjzw8jyE26gD5A/2_dolor_inmediato_caos,_saturacion,_ruido_mental_(1).png',
    alt: 'Mujer con insomnio por estrés laboral'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/wwb2Wx2FpuNg8vUkVV8q7B/2_dolor_inmediato_caos,_saturacion,_ruido_mental_(2).png',
    alt: 'Profesional estresada en oficina'
  }];
  // Auto-advance every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);
  return <section className="block md:hidden py-8 bg-black relative overflow-hidden" data-id="element-384">
      {/* Subtle glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-gold-500/5 via-transparent to-transparent pointer-events-none" data-id="element-385"></div>

      <div className="relative px-4" data-id="element-386">
        {/* Compact luxury carousel */}
        <div className="relative h-[400px] rounded-2xl overflow-hidden bg-gradient-to-br from-dark-900 to-black border border-gold-500/20 shadow-[0_0_30px_rgba(212,175,55,0.15)]" data-id="element-387">
          <AnimatePresence mode="wait" data-id="element-388">
            <motion.div key={currentSlide} initial={{
            opacity: 0,
            scale: 1.05
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} className="absolute inset-0 flex items-center justify-center p-4" data-id="element-389">
              <img src={slides[currentSlide].image} alt={slides[currentSlide].alt} className="max-w-full max-h-full object-contain drop-shadow-2xl" data-id="element-390" />

              {/* Subtle vignette */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" data-id="element-391"></div>
            </motion.div>
          </AnimatePresence>

          {/* Slide counter - top right */}
          <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/10 z-10" data-id="element-392">
            <span className="text-white text-xs font-mono" data-id="element-393">
              {String(currentSlide + 1).padStart(2, '0')}/
              {String(slides.length).padStart(2, '0')}
            </span>
          </div>
        </div>

        {/* Elegant progress dots */}
        <div className="flex justify-center items-center gap-2 mt-4" data-id="element-394">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className="relative group" aria-label={`Ir a imagen ${index + 1}`} data-id="element-395">
              <div className={`transition-all duration-500 rounded-full ${index === currentSlide ? 'w-8 h-1.5 bg-gold-500' : 'w-1.5 h-1.5 bg-gray-700 group-active:bg-gray-600'}`} data-id="element-396">
                {index === currentSlide && <motion.div className="absolute inset-0 bg-gold-400 rounded-full origin-left" initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              duration: 3,
              ease: 'linear'
            }} data-id="element-397" />}
              </div>
            </button>)}
        </div>
      </div>
    </section>;
}